import dayjs from '../../../utils/dayjs';
import { BlockStack, Text, Tooltip } from '@shopify/polaris';
import { ENUM_CALL_STATUS } from 'queries/trip_manifest.query';
import type { TypedOrderCallLog } from 'queries/orders.query';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';

const getCallStatusLabel = (callStatus?: string) => {
  switch (callStatus) {
    case ENUM_CALL_STATUS.COMPLETED:
      return 'Đã gọi thành công';
    case ENUM_CALL_STATUS.NO_ANSWER:
      return 'Khách không trả lời';
    case ENUM_CALL_STATUS.INVALID_NUMBER:
      return 'Số điện thoại không tồn tại';
    case ENUM_CALL_STATUS.NOT_CALLED:
      return 'Không gọi được';
    case ENUM_CALL_STATUS.UNTOUCHED:
      return 'Chưa gọi';
    default:
      return callStatus || '--';
  }
};

/**
 *
 * @param callStatus
 * @param message
 * @param timestamp
 * @returns
 * @deprecated KHÔNG DÙNG NỮA ...
 */
export const callStatusCallbackForDisplay = (callStatus: string, message?: string, timestamp?: bigint, callLogs?: TypedOrderCallLog[]) => {
  const formattedTime = timestamp ? dayjs(new Date(Number(timestamp))).format('HH:mm') : '--';
  let statusText = '';
  let color = 'var(--p-color-icon-secondary)';

  switch (callStatus) {
    case ENUM_CALL_STATUS.UNTOUCHED:
      statusText = 'Chưa gọi';
      break;
    case ENUM_CALL_STATUS.COMPLETED:
      statusText = `Đã gọi thành công lúc ${formattedTime} bởi ${message || '--'}`;
      color = 'var(--p-color-icon-emphasis)';
      break;
    case ENUM_CALL_STATUS.NO_ANSWER:
      statusText = `Khách không trả lời lúc ${formattedTime} bởi ${message || '--'}`;
      color = 'var(--p-color-icon-critical)';
      break;
    case ENUM_CALL_STATUS.INVALID_NUMBER:
      statusText = `Số điện thoại không tồn tại lúc ${formattedTime} bởi ${message || '--'}`;
      color = 'var(--p-color-icon-critical)';
      break;
    case ENUM_CALL_STATUS.NOT_CALLED:
      statusText = `Không gọi được lúc ${formattedTime} bởi ${message || '--'}`;
      color = 'var(--p-color-icon-critical)';
      break;
    default:
      return null;
  }

  const tooltipContent = callLogs ? (
    <BlockStack gap="200">
      <Text as="p">{statusText}</Text>
      <table style={{ borderCollapse: 'collapse', textAlign: 'left' }}>
        <thead>
          <tr>
            <th style={{ paddingRight: 12 }}>TÀI XẾ</th>
            <th style={{ paddingRight: 12 }}>T.TRẠNG</th>
            <th>LÚC</th>
          </tr>
        </thead>
        <tbody>
          {callLogs.length ? (
            callLogs.map((log, index) => (
              <tr key={String(log.id ?? index)}>
                <td style={{ paddingRight: 12 }}>{log.caller_data?.display_name || '--'}</td>
                <td style={{ paddingRight: 12 }}>{getCallStatusLabel(log.call_status)}</td>
                <td>{log.createdAt ? dayjs(Number(log.createdAt)).format('HH:mm DD/MM') : '--'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3}>Chưa có lịch sử gọi</td>
            </tr>
          )}
        </tbody>
      </table>
    </BlockStack>
  ) : (
    statusText
  );

  return (
    <Tooltip content={tooltipContent} width={'wide'}>
      <FontAwesomeIcon size="lg" icon={faPhoneVolume} color={color} />
    </Tooltip>
  );
};

